import * as React from 'react';
import { History } from 'history';
import AuthStore from '../stores/AuthStore';

export interface Props {
    history: History;
}

interface State {
    isValid: boolean;
}

export default class LoginForm extends React.PureComponent<Props> {

    state: State;

    constructor(props) {
        super(props);
        this.state = {
            isValid: false,
        };
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-4 offset-md-4">
                    <form onSubmit={this._onSubmit} style={styles.form}>
                        <div className="form-group">
                            <label htmlFor="emailInput">Email address</label>
                            <input
                                type="email"
                                className="form-control"
                                id="emailInput"
                                placeholder="Enter email"
                                onChange={this._onUsernameChange}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="passwordInput">Password</label>
                            <input
                                type="password"
                                className="form-control"
                                id="passwordInput"
                                placeholder="Password"
                                onChange={this._onPasswordChange}
                            />
                        </div>
                        <button type="submit" className="btn btn-primary">Submit</button>
                    </form>
                </div>
            </div>
        );
    }

    _onUsernameChange = ({ target: { value } }) => {
        AuthStore.username = value;
    }

    _onPasswordChange = ({ target: { value } }) => {
        AuthStore.password = value;
    }

    _onSubmit = e => {
        e.preventDefault();
        const { history } = this.props;

        AuthStore.getAccessCode()
        .then(() => {
            history.push('/organisations');
        })
        .catch(() => {
            // Show error and clear code
            alert('Incorrect credentials');
        });
    }
}


const styles = {
    form: {
        marginTop: '5rem',
        padding: '2rem',
        border: '1px solid #eee',
        borderRadius: '10px',
    },
};



// WEBPACK FOOTER //
// ./src/components/LoginForm.tsx